/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, Input, InputSignal, signal, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SendUpdateRouteService } from '../send-update-route.service';
import Swal from 'sweetalert2';
import { catchError, of, throwError } from 'rxjs';
import { NavigationService } from 'src/app/services/navigation.service';
import { ToolsService } from 'src/app/services/tools.service';
import { DebugService } from 'src/app/services/debug.service';

@Component({
  selector: 'cicerone-update-route',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './update-route.component.html',
  styleUrls: ['./update-route.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UpdateRouteComponent {
    private debugService = inject(DebugService);

    public isSaveRoute: InputSignal<any> = input<any>(false);
    private sendUpdateService = inject(SendUpdateRouteService);
    private navigationService = inject(NavigationService)
    public tools = inject(ToolsService);
    public translate = inject(TranslateService);
    public additionalInfo = computed(() => this.sendUpdateService.userData()?.info);
    public updatingRoute = signal(false);
    public item = computed(() => this.sendUpdateService.item() || this.sendUpdateService.userData()?.info);
    public routeName = this.item().name ?? {};
  
    goBack() {
      this.navigationService.goBack();
    }

    update(texarea){
      const isEnteredName = Object.values(this.routeName)?.some(text => text && text !== '');
      const data = { routeName: isEnteredName ? this.routeName : null, additionalInfo: texarea };
      this.updatingRoute.set(true);
      this.sendUpdateService.updatedRoute(data)
        .pipe(
          catchError((err) => {
            this.updatingRoute.set(false);
            Swal.fire({ icon: 'error', title: '', text: this.translate.instant('Ha ocurrido un error al actualizar la ruta') })
            return throwError(() => new Error('HTTP request failed', { cause: err }));
          }),
        )
        .subscribe(response => {
          this.debugService.debug(response, '[TechPageComponent] Update Route API Response');
          this.updatingRoute.set(false);
          Swal.fire({
            title: '',
            text: this.translate.instant('Su información ha sido actualizada'),
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            timer: 2500,
            timerProgressBar: true,
          }).then((result) => {
            this.goBack()
          })   
      });
    }

    focusin(evt) {
      evt.stopPropagation();
  }

  insertText(value, lang){
    this.routeName[lang] = value;
    this.sendUpdateService.item.update(prev => ({...prev, name: this.routeName}))
  }

}
